import React from "react";
import "./styles.css";

const Header = () => (
  <header className="home-header">
    <h2>نجوم حلی 6</h2>
    <h1>
      <span>“</span> Astronomy <span>”</span>
    </h1>
    <p>
      بهترین جا برای خوندن جدید ترین و <br /> مهم ترین اتفاقات جهان هستی
    </p>
  </header>
);

export default Header;